export function makeTransparent(
  color: string,
  opacity: number,
  darkenPercent = 0,
) {
  // Если цвет уже в формате rgb/rgba
  if (color.startsWith("rgb")) {
    const matches = color.match(/\d+/g);
    if (matches && matches.length >= 3) {
      let [r, g, b] = [
        parseInt(matches[0]),
        parseInt(matches[1]),
        parseInt(matches[2]),
      ];

      // Добавляем чёрного (затемняем)
      if (darkenPercent > 0) {
        r = Math.floor(r * (1 - darkenPercent / 100));
        g = Math.floor(g * (1 - darkenPercent / 100));
        b = Math.floor(b * (1 - darkenPercent / 100));
      }

      return `rgba(${r}, ${g}, ${b}, ${opacity})`;
    }
  }

  // Если hex
  if (color.startsWith("#")) {
    let hex = color.slice(1);
    if (hex.length === 3) {
      hex = hex
        .split("")
        .map((c) => c + c)
        .join("");
    }
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Добавляем чёрного (затемняем)
    if (darkenPercent > 0) {
      r = Math.floor(r * (1 - darkenPercent / 100));
      g = Math.floor(g * (1 - darkenPercent / 100));
      b = Math.floor(b * (1 - darkenPercent / 100));
    }

    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  }

  return color;
}
